import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField'
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { Stack, Divider } from '@mui/material';
import { app } from '../config/firebase';
import { collection, doc, getFirestore, setDoc } from "firebase/firestore";

// TODO remove, this demo shouldn't need to reset the theme.
const db = getFirestore(app);

export default function Contactus() {
  const handleSubmit = async(event) => {
    event.preventDefault();
    const data = Object.fromEntries(new FormData(event.currentTarget));
    try {
      const docRef = doc(collection(db, 'contact-messages'));
      await setDoc(docRef, {
        ...data,
        id: docRef.id,
      });
    } catch (error) {
    }
  };




  return (
    <Container maxWidth={false} disableGutters
    sx={{
        backgroundImage: "radial-gradient(circle at top left, rgba(40, 40, 40, 0.79) 0%, rgba(40, 40, 40, 0.86) 100%), url('https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/todofix%2Fmedia%2Ftodofix_bakground_2.png?alt=media&token=d076a0e4-3aa9-44f4-b624-35345eeb5f1f') !important",
        pt:24,
        pb:24,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        
        }}
    >
    <Grid container alignItems="center" justifyContent="center" component="main"> 
      <Grid item lg = {6} md = {6} xl = {6}  sm = {12}  xs = {12}>   
        <Stack spacing={2} sx={{padding:8}}>
            <Typography variant="h4" align="left" color="white" fontWeight="bolder">
                Contactanos
              </Typography>
                        
            <Divider flexItem sx={{ borderColor:"#fff", borderBottomWidth: '10px' ,backgroundColor:"#fff", maxWidth:"100px"}} />

            <Typography variant="body1" gutterBottom color="white" s>
            Teléfono: 221 841 0015
              </Typography>
              <Typography variant="body1" gutterBottom color="white" s>
            Correo: todofixpuebla@gmail.com
              </Typography>
              <Typography variant="body1" gutterBottom color="white" s>
              Horario de atención Lunes a Viernes de 9AM a 6PM, Sábados 9AM a 2PM
              </Typography>
        </Stack>
      </Grid>
      <Grid item lg = {6} md = {6} xl = {6}  sm = {12}  xs = {12} sx={{backgroundColor:"#252525"}}>
          <Stack spacing={2} sx={{padding:8}}>
            <Typography variant="h4" align="left" color="white" fontWeight="bolder">
              Envianos un mail
            </Typography>
            <Divider flexItem sx={{ borderColor:"#fff", borderBottomWidth: '10px' ,backgroundColor:"#fff", maxWidth:"100px"}} />
            <Box component="form" onSubmit={handleSubmit} noValidate>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                variant="filled"
              />

              <TextField
                margin="normal"
                required
                fullWidth
                id="telefono"
                label="Telefono"
                name="telefono"
                autoComplete="telephone"
                  variant="filled"
              />

              <TextField
                margin="normal"
                required
                fullWidth
                name="message"
                label="Message"
                type="message"
                id="message"     
                multiline
                rows={4}
                  variant="filled"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
              >
                Enviar
              </Button>
            </Box>
          </Stack>
        </Grid>
    </Grid>
  </Container> 
  );
}